import React, { Children } from 'react';
import styles from './List.module.scss';
import className from 'classnames/bind';

let cx = className.bind(styles);

export function List({ elem = 'ol', listStyle, className, children }) {
	if (!(elem !== 'ul' || elem !== 'ol')) {
		throw new Error('Incorrect list element provided.  Must be either "ul" pr "ol".');
	}
	const Tag = ({ ...props }) => React.createElement(elem, props);
	const classNameArray = className?.split(' ') || [];

	return (
		<Tag className={cx(['ns_list', 'list', ...classNameArray, listStyle && `listStyle-${listStyle}`])}>
			{children}
		</Tag>
	);
}
